module.exports = __webpack_public_path__ + "static/media/Mango_Shaved_Ice.aa0f05d2.png";